// libs
import React, {Fragment, useEffect, useState} from 'react';
// components 
import FormModal from './form-modal';
import Button from 'react-bootstrap/Button';
// config & functions 
// ...

function Table({loadapidata, offset, list, orgInfo, token, paginationNo}) {
	const [ShowFormModalBox, setShowFormModalBox] = useState(false);
    const [RowId, setRowId] = useState(0);

	const handFormModal = (ppid) => {
        setRowId(ppid);
        setShowFormModalBox(true);
    }

    if(list && Array.isArray(list) && list.length > 0) {
        const pNo = paginationNo ? paginationNo : 1;
        return <>
            <div className="table-responsive">
                <table className="table fs-14rem">
                    <thead>
                        <tr>
                            <th style={{minWidth: '200px'}}>Name</th>
                            <th style={{minWidth: '80px'}}>Domain</th>
                            <th style={{minWidth: '145px'}}>Address</th>
                            <th style={{minWidth: '120px'}}>Status</th>
                            <th style={{minWidth: '120px'}}>Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {list.map((data,i) => {
                            return <tr key={Math.random()}>
                                <td>{data.name}</td>
                                <td>{data.domain}</td>
                                <td>{data.address}, {data.stateLabel}, {data.cityLabel}</td>
                                <td>{(data.status && data.status === 1) ? <span className='text-success fw-bold'>Active</span>: <span className='text-danger fw-bold'>Inactive</span>}</td>
                                <td>
                                    <Button variant="secondary" onClick={() => handFormModal(data.pk_id)} className="fs-14rem me-4 p-0 border-0 bg-transparent text-primary">Update</Button>
                                </td>
                            </tr>
                        })}
                    </tbody>
                </table>
            </div>
            {(ShowFormModalBox) ? <FormModal loadapidata={loadapidata} apidataparams={(offset == 1) ? 0 : offset} setshowformmodalbox={setShowFormModalBox} rowid={RowId} token={token} orginfo={orgInfo} /> : null}
        </>
    } else {
        return null;
    }
}

export default Table;